import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFavroComponent } from './simple-icons-favro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFavroComponent ],
    exports:      [ SimpleIconsFavroComponent ],
    bootstrap:    []
})
export class SimpleIconsFavroModule {}
